import React from 'react';
import { Link } from 'react-router-dom';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&display=swap');

  .vedo-footer {
    background: #1c2128;
    border-top: 1px solid rgba(255,255,255,0.07);
    font-family: 'DM Sans', sans-serif;
  }

  /* ── Faixa principal ── */
  .vedo-footer__main {
    max-width: 1280px;
    margin: 0 auto;
    padding: 32px 24px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    text-align: center;
  }

  /* Logo PayPal */
  .vedo-footer__paypal {
    opacity: 0.85;
    transition: opacity 0.22s ease;
  }
  .vedo-footer__paypal:hover { opacity: 1; }
  .vedo-footer__paypal img {
    height: 32px;
    width: auto;
    display: block;
  }

  /* Texto institucional */
  .vedo-footer__text {
    font-size: 13px;
    color: rgba(240,244,248,0.5);
    line-height: 1.6;
    max-width: 560px;
  }
  .vedo-footer__text strong {
    color: rgba(240,244,248,0.8);
    font-weight: 500;
  }

  .vedo-footer__group-link {
    color: rgba(240,244,248,0.8);
    text-decoration: none;
    border-bottom: 1px solid rgba(240,244,248,0.25);
    transition: color 0.22s ease, border-color 0.22s ease;
  }
  .vedo-footer__group-link:hover {
    color: #00adb5;
    border-bottom-color: rgba(0,173,181,0.5);
  }

  /* Contatos inline */
  .vedo-footer__contacts {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 6px 16px;
    font-size: 13px;
    color: rgba(240,244,248,0.45);
  }

  .vedo-footer__contact-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .vedo-footer__contact-item a {
    color: rgba(0,173,181,0.85);
    text-decoration: none;
    transition: color 0.22s ease;
  }
  .vedo-footer__contact-item a:hover { color: #00adb5; }

  .vedo-footer__dot {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: rgba(240,244,248,0.2);
    flex-shrink: 0;
  }

  @media (max-width: 480px) {
    .vedo-footer__dot { display: none; }
    .vedo-footer__contacts { flex-direction: column; gap: 6px; }
  }

  /* ── Faixa inferior ── */
  .vedo-footer__bottom {
    border-top: 1px solid rgba(255,255,255,0.06);
    padding: 14px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
  }

  @media (min-width: 560px) {
    .vedo-footer__bottom {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .vedo-footer__copy {
    font-size: 11.5px;
    color: rgba(240,244,248,0.25);
    letter-spacing: 0.03em;
  }

  .vedo-footer__privacy {
    font-size: 11.5px;
    color: rgba(240,244,248,0.35);
    text-decoration: none;
    letter-spacing: 0.03em;
    transition: color 0.22s ease;
    padding: 2px 0;
    border-bottom: 1px solid transparent;
  }
  .vedo-footer__privacy:hover {
    color: #00adb5;
    border-bottom-color: rgba(0,173,181,0.4);
  }
`;

function Footer() {
  const ano = new Date().getFullYear();

  return (
    <>
      <style>{styles}</style>

      <footer className="vedo-footer">
        <div className="vedo-footer__main">

          {/* PayPal */}
          <a
            href="https://www.paypal.com"
            target="_blank"
            rel="noopener noreferrer"
            className="vedo-footer__paypal"
          >
            <img
              src="https://www.paypalobjects.com/webstatic/pt_PT/mktg/logo-center/bdg_powered_by_pp_pt.png"
              alt="Powered by PayPal"
            />
          </a>

          {/* Texto institucional */}
          <p className="vedo-footer__text">
            Empresa do Grupo{' '}
            <strong>
              <a
                href="https://af3.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="vedo-footer__group-link"
              >
                AF3 Soluções
              </a>
            </strong>
            {' '} — Consultoria em Domínios e Marca
          </p>

          {/* Contatos */}
          <div className="vedo-footer__contacts">
            <div className="vedo-footer__contact-item">
              Precisa de ajuda?
            </div>
            <div className="vedo-footer__dot" />
            <div className="vedo-footer__contact-item">
              <a href="mailto:dominios@vedo.com.br">dominios@vedo.com.br</a>
            </div>
            <div className="vedo-footer__dot" />
            <div className="vedo-footer__contact-item">
              <a href="tel:+551150502769">11 97432-2795</a>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="vedo-footer__bottom">
          <span className="vedo-footer__copy">
            © {ano} VEDO · Todos os direitos reservados
          </span>
          <Link to="/politica-de-privacidade" className="vedo-footer__privacy">
            Política de Privacidade
          </Link>
        </div>
      </footer>
    </>
  );
}

export default Footer;
